import React from "react";
import { View } from "react-native";
import { styles, ids } from "./styles";
import { ScreenNameList } from "@lib/utilities/Constants";
import NavigationBar from "../../components/navigationBar/NavigationBar";
import PDFView from "../../components/pdfView/PDFView";
import { usePDFViewer } from "@lib/hooks/docs/usePDFViewer";
import commonStyle from "../../assets/styles/common-style";
import CustomAlert from "../../components/common/CustomAlert";
import { messages } from "../../resources/strings";
import { Button } from "react-native";
import FullScreenLoader from "../../components/common/FullScreenLoader";

const PDFViewer = ({ route, navigation }: any) => {
  const document = route.params.document;
  const {
    isLoading,
    pdfSource,
    setErrorHandle,
    toggleModal,
    handleLoadComplete,
    handlePageChanged,
    handleError,
    handleLinkPress,
    errorHandle,
    handleInvalidTokenCase,
    downloadPdf,
    downloadLoader,
  } = usePDFViewer({
    document,
    navigation,
  });

  const Header = () => (
    <View style={[styles.navigation]} dataSet={{ media: ids.navigation }}>
      <NavigationBar
        data={{
          screenName: ScreenNameList.pdfViewer,
          displayName: document.fileName,
        }}
        barNavigation={navigation}
        onNoInternet={() => {
          setErrorHandle(messages.error.youAreOffline);
        }}
        onBackPress={() => navigation.goBack()}
        onDownloadPress={downloadPdf}
        onProfilePress={() => {
          toggleModal();
        }}
        downloadIndicator={downloadLoader}
      />
    </View>
  );

  return (
    <View
      style={[styles.containerFluid]}
      dataSet={{ media: ids.containerFluid }}
    >
      <Header />
      <View style={styles.container} dataSet={{ media: ids.container }}>
        { pdfSource && (
          // @ts-ignore
          <PDFView
            trustAllCerts={false}
            source={pdfSource ?? {}}
            renderActivityIndicator={(progress: any) => (
              <></>
            )}
            onLoadComplete={handleLoadComplete}
            onPageChanged={handlePageChanged}
            onError={handleError}
            onPressLink={handleLinkPress}
            style={styles.pdf}
          />
        )}
      </View>
      {(isLoading || downloadLoader) && <FullScreenLoader screenName={ScreenNameList.pdfViewer} downloadLoader={downloadLoader} />}
      {errorHandle != messages.error.noError && !isLoading && (
          <CustomAlert
            showReload={false}
            data={{
              message: errorHandle,
              screenName: ScreenNameList.pdfViewer,
            }}
            onEndTimer={() => {
              setErrorHandle(messages.error.noError);
            }}
            onEndLogoutTimer={() => {
              handleInvalidTokenCase();
            }}
          />
      )}
    </View>
  );
};

export default PDFViewer;
